// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1XL7V","name":"ConsentHeader_name__3B_kH","birthday":"ConsentHeader_birthday__35h4v","skeleton":"ConsentHeader_skeleton__1pMmO"};